//
//
//
//
//
//
//
//

const STATUS = {
    '最新取证': '最新取证：近期已取得预售许可证的楼盘',
    '最新摇号': '最新摇号：复核结果已出等待摇号或近期已摇号完成的楼盘',
    '摇号剩余': '在售楼盘：选房结束后还有剩余可售房源的楼盘',
    '在售楼盘': '在售楼盘：选房结束后还有剩余可售房源的楼盘',
    '热门公寓': '热门公寓：本页面所展示项目均为40年产权的商业、办公',
    '即将预售': '即将预售：近期将会取得预售许可证的楼盘，取证后才可进行登记报名'
}
export default {
    props: {
        status: {
            type: String
        }
    },
    data () {
        return {
            show: false
        }
    },
    computed: {
        content () {
            console.error(this.status)
            return STATUS[this.status] || ''
        }
    },
    watch: {
        content:{
            handler (latest, old) {
                if (latest != old) {
                    this.show = Boolean(latest)
                }
            },
            immediate: true
        }
    },
    methods: {
        onClose () {
            this.show = false
        }
    }
}
